import { render, staticRenderFns } from "./profile-view-write-up.vue?vue&type=template&id=39bf1578&scoped=true&"
import script from "./profile-view-write-up.vue?vue&type=script&lang=js&"
export * from "./profile-view-write-up.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-write-up.vue?vue&type=style&index=0&id=39bf1578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf1578",
  null
  
)

export default component.exports